import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { getAuditLog, type AuditLogEntry, type AuditLogFilters } from '@/api/audit-log.api'
import { Status } from '@/types/general-types'
import { getErrorMessage } from '@/utils/utils'
import { resetStore } from '@/store/actions/reset'

interface AuditLogState {
  data: AuditLogEntry[]
  total: number
  page: number
  limit: number
  status: Status
  requestId: string | null
}

const initialState: AuditLogState = {
  data: [],
  total: 0,
  page: 1,
  limit: 20,
  status: 'idle',
  requestId: null,
}

export const fetchAuditLog = createAsyncThunk<
  { data: AuditLogEntry[]; total: number; page: number; limit: number },
  AuditLogFilters
>('auditLog/fetch', async (filters, { rejectWithValue }) => {
  try {
    return await getAuditLog(filters)
  } catch (error) {
    return rejectWithValue(getErrorMessage(error))
  }
})

const auditLogSlice = createSlice({
  name: 'auditLog',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditLog.pending, (state, action) => {
        state.requestId = action.meta.requestId
        state.status = 'loading'
      })
      // Odpowiedzi wracają w kolejności sieci, nie wysłania. Bez tego porównania wolniejsze
      // żądanie sprzed zmiany filtra nadpisuje wynik nowszego i tabela pokazuje wiersze,
      // których ustawione filtry nie obejmują.
      .addCase(fetchAuditLog.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) return

        state.status = 'succeeded'
        state.data = action.payload.data
        state.total = action.payload.total
        state.page = action.payload.page
        state.limit = action.payload.limit
      })
      .addCase(fetchAuditLog.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) return

        state.status = 'failed'
      })
      .addCase(resetStore, () => initialState)
  },
})

export default auditLogSlice.reducer
